import { Capacitor } from '@capacitor/core';
import {AndroidBiometryStrength, BiometricAuth, BiometryError, BiometryErrorType, BiometryType} from '@aparajita/capacitor-biometric-auth';
import {login} from '@/services/AuthService';
import router from '@/router';
import {getBiometricLSKeyByDomain, setButtonContentDefault, setButtonContentLoading, setButtonContentSuccess} from '@/helper';

export async function authenticateWithBiometric(withLoginRequest = true) {
    const biometricUUID = localStorage.getItem(getBiometricLSKeyByDomain('BIOMETRIC_UUID'));
    const biometricActive = localStorage.getItem(getBiometricLSKeyByDomain('BIOMETRIC_ACTIVE'));

    if (Capacitor.isNativePlatform() && biometricUUID && biometricActive) {
        const info = await BiometricAuth.checkBiometry();
        if (info.isAvailable) {
            console.log('Biometry is available', info);
            void _authenticate(withLoginRequest);
        } else {
            console.log('Biometry is not available', info);
        }
    }
}

export async function getAvailableTypeString() {
    const info = await BiometricAuth.checkBiometry();
    if (info.biometryType === BiometryType.faceId) {
        return 'Face ID';
    }
    if (info.biometryType === BiometryType.touchId) {
        return 'Touch ID';
    }
    if (info.biometryType === BiometryType.fingerprintAuthentication) {
        return 'otisku prstu';
    }
    if (info.biometryType === BiometryType.faceAuthentication) {
        return 'oveření obličeje';
    }
    return 'None';
}

// required face id when app resumes
/*async function _register() {
    authenticate(await BiometricAuth.checkBiometry())

    try {
        appListener = await BiometricAuth.addResumeListener(authenticate)
    } catch (error) {
        if (error instanceof Error) {
            console.error(error.message)
        }
    }
}*/

/*
async function _onComponentUnmounted() {
    await appListener?.remove()
}
*/

async function _authenticate(withLoginRequest = true) {
    setButtonContentLoading('btn-biometric-login');
    try {
        await BiometricAuth.authenticate({
            reason: 'Please authenticate',
            cancelTitle: 'Cancel',
            allowDeviceCredential: true,
            iosFallbackTitle: 'Use passcode',
            androidTitle: 'Biometric login',
            androidSubtitle: 'Log in using biometric authentication',
            androidConfirmationRequired: false,
            androidBiometryStrength: AndroidBiometryStrength.weak,
        })
        console.log('Authenticated successfully');

        if (withLoginRequest) {
            login(null, null, localStorage.getItem(getBiometricLSKeyByDomain('BIOMETRIC_UUID')))
                .then((response) => {
                    console.log('Logged in successfully');
                    if (response.access_token) {
                        router.push('/home');
                        setButtonContentSuccess('btn-biometric-login');
                    }
                }, (error) => {
                    setButtonContentDefault('btn-biometric-login');
                    console.log('Login failed', error);
                });
        } else {
            setButtonContentSuccess('btn-biometric-login');
        }

    } catch (error) {
        // error is always an instance of BiometryError.
        setButtonContentDefault('btn-biometric-login');
        if (error instanceof BiometryError) {
            console.log(error);
            if (error.code !== BiometryErrorType.userCancel) {
                // Display the error.
            }
        }
    }
}
